import { Map } from 'immutable';

import {
  ContainerEditActionTypes,
  ContainerEditActions,
} from './container-edit.actions';
import { ContainerActions } from './container.actions';
import { CreateOrUpdate } from './create-or-update';

export function libraryNotesBeingEditedReducer(
  state: Map<string, CreateOrUpdate>,
  action: ContainerActions | ContainerEditActions,
): Map<string, CreateOrUpdate> {
  switch (action.type) {
    case ContainerEditActionTypes.DELETE_RESOURCE_ITEM_LIBRARY_NOTE:
    case ContainerEditActionTypes.CANCEL_UPDATE_RESOURCE_ITEM_LIBRARY_NOTE:
    case ContainerEditActionTypes.CONFIRM_UPDATE_RESOURCE_ITEM_LIBRARY_NOTE: {
      const { id } = action.payload;
      return state.remove(id);
    }

    case ContainerEditActionTypes.UPDATE_RESOURCE_ITEM_LIBRARY_NOTE: {
      const { id } = action.payload;
      return state.merge({ [id]: action.payload.createOrUpdate });
    }

    case ContainerEditActionTypes.CONFIRM_DELETE_ITEM: {
      const { item } = action.payload;
      return state.remove(item.id);
    }

    case ContainerEditActionTypes.CONFIRM_DELETE_SECTION: {
      const { descendantItems } = action.payload;
      return state.removeAll(descendantItems);
    }

    default: {
      return state;
    }
  }
}
